import { render, staticRenderFns } from "./CartView.vue?vue&type=template&id=5c157418&scoped=true&"
import script from "./CartView.vue?vue&type=script&lang=js&"
export * from "./CartView.vue?vue&type=script&lang=js&"
import style0 from "./CartView.vue?vue&type=style&index=0&id=5c157418&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c157418",
  null
  
)

export default component.exports